module.exports = __webpack_public_path__ + "img/12.3ae51d40.png";